import { render, staticRenderFns } from "./DraftAttachmentDownloadButton.vue?vue&type=template&id=0ff81a78&scoped=true"
import script from "./DraftAttachmentDownloadButton.vue?vue&type=script&lang=ts"
export * from "./DraftAttachmentDownloadButton.vue?vue&type=script&lang=ts"
import style0 from "./DraftAttachmentDownloadButton.vue?vue&type=style&index=0&id=0ff81a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff81a78",
  null
  
)

export default component.exports